import React from 'react';
import { Key, ShieldAlert, Eye, UserX } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Stealer Leaks feature
 * Displays information about the Stealer Leaks feature and its benefits
 */
export const StealerLeaksFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Stealer Leaks Monitoring"
      description="Detect and respond to credentials stolen by malware and infostealer campaigns targeting your organization and employees."
      icon={<Key className="h-8 w-8 text-blue-600" />}
      featureName="stealer-leaks"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Key className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Credential Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Monitor for stolen credentials from malware campaigns, infostealer logs, and dark web marketplaces.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <ShieldAlert className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Malware Detection</h3>
          </div>
          <p className="text-gray-400">
            Identify when your organization's assets are targeted by credential-stealing malware and infostealer campaigns.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Eye className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Dark Web Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Monitor dark web marketplaces and forums where stolen credentials and infostealer logs are traded and sold.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <UserX className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Compromised Account Detection</h3>
          </div>
          <p className="text-gray-400">
            Quickly identify compromised accounts and systems to prevent unauthorized access and data theft.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
